import { navLinks } from '../content';

export default function SiteFooter() {
  return (
    <footer id="footer" className="bg-emerald-900 text-emerald-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/15 text-white">
                <span className="font-display text-lg font-bold leading-none">瓜</span>
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-[17px] font-bold text-white">吃瓜软件</span>
                <span className="mt-0.5 text-[10px] tracking-[0.3em] text-emerald-300/80">官网使用指南</span>
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-7 text-emerald-100/70">
              汇集吃瓜软件使用教程、操作指南、新手入门与设置技巧。从会用到底层逻辑，我们一起把功能吃透。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white">站内导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-emerald-100/70 transition-colors hover:text-white">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-emerald-100/70">
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-base"></i>
                support@chigua-soft.example
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-community-line text-base"></i>
                软件内「我的 — 帮助与反馈」
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-time-line text-base"></i>
                周一至周五 09:00 – 18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-emerald-100/50">
            © {new Date().getFullYear()} 吃瓜软件官网 · 本页面为使用指南与信息展示，仅作参考。
          </p>
          <p className="text-xs text-emerald-100/50">温馨提示：请通过官方渠道下载，谨防来路不明的安装包。</p>
        </div>
      </div>
    </footer>
  );
}